import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  state() {
    return {
      reqID: null,
      scopeID: null,
      storedValues: null,
    };
  },
  mutations,
  actions,
  getters,
};